import { useState, useEffect, useRef } from "react";
import "../Css/ClassroomPage.css";
import heroBg from '../assets/original.svg';
import AgraImg from "../assets/cities/Agra.jpg";
import AhmedabadImg from "../assets/cities/Ahmedabad.png";
import AkolaImg from "../assets/cities/Akola.png";
import AlwarImg from "../assets/cities/Alwar.png";
import AmritsarImg from "../assets/cities/Amritsar.png";
import BathindaImg from "../assets/cities/Bathinda.png";
import BengaluruImg from "../assets/cities/Bengaluru.png";
import BhagalpurImg from "../assets/cities/Bhagalpur.jpg";
import BhilaiImg from "../assets/cities/Bhilai.jpg";
import BhilwaraImg from "../assets/cities/Bhilwara.png";
import BhopalImg from "../assets/cities/Bhopal.png";
import BhubaneswarImg from "../assets/cities/Bhubaneswar.png";
import BikanerImg from "../assets/cities/Bikaner.png";
import BilaspurImg from "../assets/cities/Bilaspur.png";
import BuldanaImg from "../assets/cities/Buldana.png";
import BundiImg from "../assets/cities/Bundi.png";
import ChandigarhImg from "../assets/cities/Chandigarh.png";
import ChennaiImg from "../assets/cities/Chennai.png";
import ChhatrapatiSambhajiNagarImg from "../assets/cities/Chhatrapati_Sambhaji_Nagar.png";
import CoimbatoreImg from "../assets/cities/Coimbatore.png";
import DarbhangaImg from "../assets/cities/Darbhanga.jpg";
import DehradunImg from "../assets/cities/Dehradun.png";
import DelhiImg from "../assets/cities/Delhi.jpg";
import DibrugarhImg from "../assets/cities/Dibrugarh.jpg";
import DurgapurImg from "../assets/cities/Durgapur.jpg";
import GayaImg from "../assets/cities/Gaya.webp";
import GorakhpurImg from "../assets/cities/Gorakhpur.webp";
import GuwahatiImg from "../assets/cities/Guwahati.webp";
import GwaliorImg from "../assets/cities/Gwalior.avif";
import HisarImg from "../assets/cities/Hisar.jpg";
import HubbaliImg from "../assets/cities/Hubbali.avif";
import HyderabadImg from "../assets/cities/Hyderabad.webp";
import IndoreImg from "../assets/cities/Indore.jpg";
import JaipurImg from "../assets/cities/Jaipur.webp";
import JammuImg from "../assets/cities/Jammu.jpg";
import JodhpurImg from "../assets/cities/Jodhpur.jpg";
import KanpurImg from "../assets/cities/Kanpur.jpg";
import KharagpurImg from "../assets/cities/Kharagpur.jpg";
import KolhapurImg from "../assets/cities/Kolhapur.webp";
import KolkataImg from "../assets/cities/Kolkata.webp";
import KotaImg from "../assets/cities/Kota.jpg";
import LaturImg from "../assets/cities/Latur.png";
import LucknowImg from "../assets/cities/Lucknow.jpg";
import MaduraiImg from "../assets/cities/Madurai.avif";
import MangaluruImg from "../assets/cities/Mangaluru.jpg";
import MohaliImg from "../assets/cities/Mohali.jpg";
import MotihariImg from "../assets/cities/Motihari.jpg";
import MumbaiImg from "../assets/cities/Mumbai.jpg";
import MuzaffarpurImg from "../assets/cities/Muzaffarpur.jpg";
import MysoreImg from "../assets/cities/Mysore.jpeg";
import NagaonImg from "../assets/cities/Nagaon.jpg";
import NagpurImg from "../assets/cities/Nagpur.jpg";
import NandedImg from "../assets/cities/Nanded.jpg";
import NashikImg from "../assets/cities/Nashik.jpg";
import PanchkulaImg from "../assets/cities/Panchkula.jpg";
import PatnaImg from "../assets/cities/Patna.webp";
import PrayagrajImg from "../assets/cities/Prayagraj.jpg";
import PuducherryImg from "../assets/cities/Prayagraj.jpg";
import PuneImg from "../assets/cities/Pune.webp";
import PurneaImg from "../assets/cities/Purnea.webp";
import RaipurImg from "../assets/cities/Raipur.jpg";
import RajkotImg from "../assets/cities/Rajkot.webp";
import RanchiImg from "../assets/cities/Ranchi.jpg";
import RawatbhataImg from "../assets/cities/Rawatbhata.jpg";
import RohtakImg from "../assets/cities/Rohtak.jpg";
import SikarImg from "../assets/cities/Sikar.webp";
import SiliguriImg from "../assets/cities/Siliguri.jpg";
import SrinagarImg from "../assets/cities/Srinagar.jpg";
import SuratImg from "../assets/cities/Surat.jpg";
import TirupatiImg from "../assets/cities/Tirupati.jpg";
import UdaipurImg from "../assets/cities/Udaipur.jpg";
import UjjainImg from "../assets/cities/Ujjain.jpg";
import VadodaraImg from "../assets/cities/Vadodara.webp";
import VaranasiImg from "../assets/cities/Varanasi.webp";
import VijayawadaImg from "../assets/cities/Vijayawada.jpg";
import VijayapuraImg from "../assets/cities/Vijayapura.jpg";
import VizagImg from "../assets/cities/Vizag.webp";


const CITIES = [
  { name: "Agra", state: "Uttar Pradesh", campuses: 1, img: AgraImg  },
  { name: "Ahmedabad", state: "Gujarat", campuses: 8, img: AhmedabadImg  },
  { name: "Akola", state: "Maharashtra", campuses: 1, img: AkolaImg },
  { name: "Alwar", state: "Rajasthan", campuses: 1, img: AlwarImg },
  { name: "Amritsar", state: "Punjab", campuses: 1, img: AmritsarImg },
  { name: "Bathinda", state: "Punjab", campuses: 1, img: BathindaImg },
  { name: "Bengaluru", state: "Karnataka", campuses: 80, img: BengaluruImg },
  { name: "Bhagalpur", state: "Bihar", campuses: 1, img: BhagalpurImg },
  { name: "Bhilai", state: "Chhattisgarh", campuses: 1, img: BhilaiImg },
  { name: "Bhilwara", state: "Rajasthan", campuses: 1, img: BhilwaraImg },
  { name: "Bhopal", state: "Madhya Pradesh", campuses: 3, img: BhopalImg },
  { name: "Bhubaneswar", state: "Odisha", campuses: 9, img: BhubaneswarImg },
  { name: "Bikaner", state: "Rajasthan", campuses: 1, img: BikanerImg },
  { name: "Bilaspur", state: "Chhattisgarh", campuses: 1, img: BilaspurImg },
  { name: "Buldana", state: "Maharashtra", campuses: 1, img: BuldanaImg },
  { name: "Bundi", state: "Rajasthan", campuses: 1, img: BundiImg },
  { name: "Chandigarh", state: "Chandigarh (UT)", campuses: 8, img: ChandigarhImg },
  { name: "Chennai", state: "Tamil Nadu", campuses: 9, img: ChennaiImg },
  { name: "Chhatrapati Sambhaji Nagar", state: "Maharashtra", campuses: 1, img: ChhatrapatiSambhajiNagarImg },
  { name: "Coimbatore", state: "Tamil Nadu", campuses: 1, img: CoimbatoreImg },
  { name: "Darbhanga", state: "Bihar", campuses: 4, img: DarbhangaImg },
  { name: "Dehradun", state: "Uttarakhand", campuses: 2, img: DehradunImg },
  { name: "Delhi", state: "Delhi (UT)", campuses: 16, img: DelhiImg },
  { name: "Dibrugarh", state: "Assam", campuses: 1, img: DibrugarhImg },
  { name: "Durgapur", state: "West Bengal", campuses: 1, img: DurgapurImg },
  { name: "Gaya", state: "Bihar", campuses: 1, img: GayaImg },
  { name: "Gorakhpur", state: "Uttar Pradesh", campuses: 5, img: GorakhpurImg },
  { name: "Guwahati", state: "Assam", campuses: 1, img: GuwahatiImg },
  { name: "Gwalior", state: "Madhya Pradesh", campuses: 1, img: GwaliorImg },
  { name: "Hisar", state: "Haryana", campuses: 1, img: HisarImg },
  { name: "Hubbali", state: "Karnataka", campuses: 1, img: HubbaliImg },
  { name: "Hyderabad", state: "Telangana", campuses: 9, img: HyderabadImg },
  { name: "Indore", state: "Madhya Pradesh", campuses: 9, img: IndoreImg },
  { name: "Jaipur", state: "Rajasthan", campuses: 9, img: JaipurImg },
  { name: "Jammu", state: "Jammu & Kashmir", campuses: 2, img: JammuImg },
  { name: "Jodhpur", state: "Rajasthan", campuses: 8, img: JodhpurImg },
  { name: "Kanpur", state: "Uttar Pradesh", campuses: 2, img: KanpurImg },

  { name: "Kharagpur", state: "West Bengal", campuses: 1, img: KharagpurImg },
  { name: "Kolhapur", state: "Maharashtra", campuses: 9, img: KolhapurImg },
  { name: "Kolkata", state: "West Bengal", campuses: 4, img: KolkataImg },
  { name: "Kota", state: "Rajasthan", campuses: 4, img: KotaImg },
  { name: "Latur", state: "Maharashtra", campuses: 1, img: LaturImg },
  { name: "Lucknow", state: "Uttar Pradesh", campuses: 9, img: LucknowImg },
  { name: "Madurai", state: "Tamil Nadu", campuses: 1, img: MaduraiImg },
  { name: "Mangaluru", state: "Karnataka", campuses: 1, img: MangaluruImg },
  { name: "Mohali", state: "Punjab", campuses: 3, img: MohaliImg },
  { name: "Motihari", state: "Bihar", campuses: 1, img: MotihariImg },
  { name: "Mumbai", state: "Maharashtra", campuses: 16, img: MumbaiImg },
  { name: "Muzaffarpur", state: "Bihar", campuses: 1, img: MuzaffarpurImg },
  { name: "Mysore", state: "Karnataka", campuses: 1, img: MysoreImg },
  { name: "Nagaon", state: "Assam", campuses: 1, img: NagaonImg },
  { name: "Nagpur", state: "Maharashtra", campuses: 4, img: NagpurImg },
  { name: "Nanded", state: "Maharashtra", campuses: 3, img: NandedImg },
  { name: "Nashik", state: "Maharashtra", campuses: 10, img: NashikImg },
  { name: "Panchkula", state: "Haryana", campuses: 1, img: PanchkulaImg },
  { name: "Patna", state: "Bihar", campuses: 4, img: PatnaImg },
  { name: "Prayagraj", state: "Uttar Pradesh", campuses: 1, img: PrayagrajImg },
  { name: "Puducherry", state: "Puducherry (UT)", campuses: 11, img: PuducherryImg },
  { name: "Pune", state: "Maharashtra", campuses: 8, img: PuneImg },
  { name: "Purnea", state: "Bihar", campuses: 1, img: PurneaImg },
  { name: "Raipur", state: "Chhattisgarh", campuses: 1, img: RaipurImg },
  { name: "Rajkot", state: "Gujarat", campuses: 1, img: RajkotImg },
  { name: "Ranchi", state: "Jharkhand", campuses: 8, img: RanchiImg },
  { name: "Rawatbhata", state: "Rajasthan", campuses: 1, img: RawatbhataImg },
  { name: "Rohtak", state: "Haryana", campuses: 8, img: RohtakImg },
  { name: "Sikar", state: "Rajasthan", campuses: 8, img: SikarImg },
  { name: "Siliguri", state: "West Bengal", campuses: 1, img: SiliguriImg },
  { name: "Srinagar", state: "Jammu & Kashmir", campuses: 4, img: SrinagarImg },
  { name: "Surat", state: "Gujarat", campuses: 8, img: SuratImg },
  { name: "Tirupati", state: "Andhra Pradesh", campuses: 1, img: TirupatiImg },
  { name: "Udaipur", state: "Rajasthan", campuses: 1, img: UdaipurImg },
  { name: "Ujjain", state: "Madhya Pradesh", campuses: 1, img: UjjainImg },
  { name: "Vadodara", state: "Gujarat", campuses: 3, img: VadodaraImg },
  { name: "Varanasi", state: "Uttar Pradesh", campuses: 10, img: VaranasiImg },
  { name: "Vijayawada", state: "Andhra Pradesh", campuses: 11, img: VijayawadaImg },
  { name: "Vijayapura", state: "Karnataka", campuses: 1, img: VijayapuraImg },
  { name: "Vizag", state: "Andhra Pradesh", campuses: 1, img: VizagImg },
];

const STREAMS = ["JEE Main", "JEE Main Advanced", "NEET", "Grade 6–12"];

function toSlug(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

function StreamPopup({ city, onClose }) {
  const [selected, setSelected] = useState(null);
  const ref = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const handleExplore = () => {
    if (!selected) return;
    window.location.href = `/${toSlug(city.name)}/${toSlug(selected)}`;
  };

  return (
    <div className="popup-overlay">
      <div className="popup-card" ref={ref}>
        <button className="popup-close" onClick={onClose} aria-label="Close">✕</button>
        <p className="popup-label">Select stream to view courses</p>
        <div className="popup-streams">
          {STREAMS.map((s) => (
            <button
              key={s}
              className={"stream-btn" + (selected === s ? " active" : "")}
              onClick={() => setSelected(s)}
            >
              {s}
            </button>
          ))}
        </div>
        <button
          className={"explore-btn" + (selected ? " enabled" : "")}
          onClick={handleExplore}
          disabled={!selected}
        >
          Explore courses
        </button>
      </div>
    </div>
  );
}

export default function ClassroomPage() {
  const [search, setSearch] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);

  const filtered = CITIES.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.state.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="cp-root">

      {/* ── Hero Section ── */}
      <section className="cp-hero">
        <img src="/original.svg" className="cp-hero-svg" alt="" aria-hidden="true" />
        <div className="cp-hero-inner">
          <div className="cp-offer-bar">
            <span className="offer-icon">📣</span>
            <strong className="offer-bold">SPECIAL OFFER !</strong>
            <span className="offer-sparkle">✦</span>
            &nbsp;&nbsp;Appear for ASAT at ₹99 and get up to 90% scholarship*
            <span className="offer-arrow">›</span>
          </div>

          <div className="cp-hero-text">
            <h1 className="cp-title">IITian's Chinmay Academy<br />Online Coaching Classes</h1>
            <p className="cp-sub">All India presence, 285+ classroom campuses</p>
            <div className="cp-search-wrap">
              <svg className="cp-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="#999" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                className="cp-search"
                placeholder="Search by city name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                autoComplete="off"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── Centers ── */}
      <section className="cp-centers">
        <div className="cp-centers-header">
          <span className="cp-centers-count">All centers: {filtered.length}</span>
          <button className="cp-state-filter">
            State: All <span className="dropdown-arrow">⌄</span>
          </button>
        </div>

        <div className="cp-grid">
          {filtered.length === 0 && (
            <div className="cp-no-results">No cities found for "{search}"</div>
          )}
          {filtered.map((city) => (
            <div
              key={city.name}
              className="cp-card"
              onClick={() => setSelectedCity(city)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setSelectedCity(city)}
            >
              <div className="cp-card-img-wrap">
                <img
                  src={city.img}
                  alt={city.name}
                  className="cp-card-img"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = `https://picsum.photos/seed/${encodeURIComponent(city.name)}/400/240`;
                  }}
                />
              </div>
              <div className="cp-card-body">
                <div className="cp-card-row">
                  <span className="cp-card-name">{city.name}</span>
                  <span className="cp-card-campuses">
                    {city.campuses} {city.campuses === 1 ? "Campus" : "Campuses"}
                  </span>
                </div>
                <div className="cp-card-state">{city.state}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Stream Popup ── */}
      {selectedCity && (
        <StreamPopup city={selectedCity} onClose={() => setSelectedCity(null)} />
      )}
    </div>
  );
}